import { useContext } from 'react'

import {
  GlobalStateContext,
  GlobalDispatchContext,
} from 'context/GlobalContextProvider'
import headerScrolled from 'actions/header/scrolled'
import closeFlashMessage from 'actions/flashMessage/close'

function useHeaderState() {
  const state = useContext(GlobalStateContext)
  const dispatch = useContext(GlobalDispatchContext)

  return {
    scrolled: state.header.scrolled,
    flashMessageCleared: state.header.flashMessageCleared,
    setHeaderScrolled: (scrolled) => dispatch(headerScrolled(scrolled)),
    clearFlashMessage: () => dispatch(closeFlashMessage()),
  }
}

export default useHeaderState
